import { useApp } from '../../context/AppContext';
import { ONBOARDING_STEPS } from '../../data/actions';

export function Onboarding() {
  const { onboardingStep, setOnboardingStep } = useApp();

  if (onboardingStep === null) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="onboarding-title"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",
        backdropFilter: "blur(6px)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
      }}
    >
      <div
        style={{
          background: "#0d1f10",
          border: "1px solid rgba(34,197,94,0.25)",
          borderRadius: "20px",
          padding: "2rem 1.75rem",
          maxWidth: "380px",
          width: "100%",
          animation: "fadeUp 0.3s ease",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }} aria-hidden="true">
          {ONBOARDING_STEPS[onboardingStep].icon}
        </div>
        <h2 
          id="onboarding-title"
          style={{ 
            fontSize: "1.35rem", 
            fontWeight: "normal", 
            color: "#f0fdf4", 
            margin: "0 0 0.65rem" 
          }}
        >
          {ONBOARDING_STEPS[onboardingStep].title}
        </h2>
        <p style={{ color: "#9ca3af", fontSize: "0.88rem", lineHeight: 1.7, margin: "0 0 1.5rem" }}>
          {ONBOARDING_STEPS[onboardingStep].body}
        </p>
        
        {/* Progress dots */}
        <div 
          style={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: "0.35rem", 
            marginBottom: "1.25rem" 
          }}
          role="progressbar"
          aria-valuenow={onboardingStep + 1}
          aria-valuemin={1}
          aria-valuemax={ONBOARDING_STEPS.length}
        >
          {ONBOARDING_STEPS.map((_, i) => (
            <div
              key={i}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: i === onboardingStep ? "#4ade80" : "rgba(255,255,255,0.15)",
                transition: "background 0.2s",
              }}
            />
          ))}
        </div>

        <button
          onClick={() => {
            if (onboardingStep < ONBOARDING_STEPS.length - 1) {
              setOnboardingStep(s => s + 1);
            } else {
              setOnboardingStep(null);
            }
          }}
          style={{
            background: "#16a34a",
            border: "none",
            color: "#fff",
            padding: "0.65rem 2rem",
            borderRadius: "10px",
            fontSize: "0.88rem",
            width: "100%",
            cursor: "pointer",
          }}
        >
          {onboardingStep < ONBOARDING_STEPS.length - 1 ? "Next →" : "Let's get started 🌱"}
        </button>
        
        {onboardingStep < ONBOARDING_STEPS.length - 1 && (
          <button
            onClick={() => setOnboardingStep(null)}
            style={{
              background: "none",
              border: "none",
              color: "#4b5563",
              fontSize: "0.73rem",
              marginTop: "0.75rem",
              cursor: "pointer",
            }}
          >
            Skip intro
          </button>
        )}
      </div>
    </div>
  );
}
